import { TCompany } from "@/api/entities/company.entity";
import { useMe } from "@/api/services/main/auth";
import { TGetMeDto } from "@/api/services/main/auth/dtos/get-me.dto";
import { FCC } from "@/types/common";
import { createContext, useContext, useMemo } from "react";
import { TUserType } from "@/types/enum";
import { LoadingScreen } from "@/components/elements/Loading/Loading";

export type InitSetupType = {
  isLoading: boolean;
  userType?: TUserType;
  user?: TGetMeDto;
  company?: TCompany;
};

export const InitSetupContext = createContext<InitSetupType | undefined>(undefined);

export const InitSetupProvider: FCC = ({ children }) => {
  const { data: meResult, isLoading } = useMe();

  const user = useMemo(() => meResult?.data, [meResult]);
  const userType: TUserType | undefined = user?.type;
  const company = useMemo(() => user?.company, [user]);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <InitSetupContext.Provider
      value={{
        user,
        company,
        isLoading,
        userType,
      }}
    >
      {children}
    </InitSetupContext.Provider>
  );
};

export const useInitSetup = (): InitSetupType => {
  const context = useContext(InitSetupContext);
  if (!context) {
    throw new Error("useInitSetup must be used within a InitSetupProvider");
  }
  return context;
};
